module.exports = __webpack_public_path__ + "static/media/Rectangle 593.b9452092.png";